export default (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24">
    <rect xmlns="http://www.w3.org/2000/svg" width="300" height="300" fill="red" ry="150" />
    <path
      fill="currentColor"
      d="M23.5 6.2c-.3-1.2-1.2-2.1-2.4-2.4C19.2 3.4 12 3.4 12 3.4s-7.2 0-9.1.4c-1.2.3-2.1 1.2-2.4 2.4C0 8.1 0 12 0 12s0 3.9.5 5.8c.3 1.2 1.2 2.1 2.4 2.4 1.9.5 9.1.5 9.1.5s7.2 0 9.1-.5c1.2-.3 2.1-1.2 2.4-2.4.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.8 15.5v-7l6.3 3.5-6.3 3.5z"
    />
  </svg>
);
